import { checkAccess } from 'app/actions/app.actions';
import {
  INSTANT_GAME_TYPE,
  DRAW_GAME_TYPE,
  VLT_GAME_TYPE,
  clearGameImages,
} from 'app/actions/game-images.actions';
import template from './game-images.html';

const VLT_GAMES_PERMISSION = 'dashboard.widget.topVltGames';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale } = session;
  const terms = dictionary.terms[locale];

  return {
    terms,
  };
};

const mapDispatchToThis = {
  clearGameImages,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'DirtyForm')
class CmsGameImagesController {
  constructor() {
    this.INSTANT_GAME_TYPE = INSTANT_GAME_TYPE;
    this.DRAW_GAME_TYPE = DRAW_GAME_TYPE;
    this.VLT_GAME_TYPE = VLT_GAME_TYPE;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.activeTabIdx = this.INSTANT_GAME_TYPE;
    this.vltGamesPermission = this.checkAccess(VLT_GAMES_PERMISSION);
    this.acceptFileFormat = this.initAcceptFileFormat();
    this.acceptFileDimensions = this.initAcceptFileDimensions();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initAcceptFileFormat() {
    return {
      [this.INSTANT_GAME_TYPE]: ['image/jpeg', 'image/jpg'],
      [this.DRAW_GAME_TYPE]: ['image/png'],
      [this.VLT_GAME_TYPE]: ['image/jpeg', 'image/jpg'],
    };
  }

  initAcceptFileDimensions() {
    return {
      [this.INSTANT_GAME_TYPE]: [
        {
          width: 261,
          height: 261,
        },
        {
          width: 522,
          height: 522,
        },
      ],
      [this.DRAW_GAME_TYPE]: [
        {
          width: 1040,
          height: 1040,
        },
      ],
      [this.VLT_GAME_TYPE]: [
        {
          width: 261,
          height: 261,
        },
        {
          width: 522,
          height: 522,
        },
      ],
    };
  }

  onTabSelect(tabId) {
    this.DirtyForm.check(this.activeTabIdx, (dirty) => {
      if (dirty) {
        this.clearGameImages();
      }
      this.activeTabIdx = tabId;
    });
  }
}

export default class CmsGameImagesComponent {
  constructor() {
    this.controller = CmsGameImagesController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/game-images-component.js